<svg
  width="28"
  height="28"
  viewBox="0 0 28 28"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M13.9987 2.33301C7.5657 2.33301 2.33203 7.56667 2.33203 13.9997C2.33203 20.4327 7.5657 25.6663 13.9987 25.6663C20.4317 25.6663 25.6654 20.4327 25.6654 13.9997C25.6654 7.56667 20.4317 2.33301 13.9987 2.33301ZM15.1654 19.7338V20.9997H12.832V19.7397C10.1032 19.3115 9.33203 17.404 9.33203 16.333H11.6654C11.6782 16.4998 11.8509 17.4997 13.9987 17.4997C15.6087 17.4997 16.332 16.8172 16.332 16.333C16.332 15.955 16.332 15.1663 13.9987 15.1663C9.9387 15.1663 9.33203 12.973 9.33203 11.6663C9.33203 10.1637 10.5325 8.65167 12.832 8.26551V7.01367H15.1654V8.30751C17.1884 8.78584 17.9654 10.4693 17.9654 11.6663H16.7987L15.632 11.6873C15.6157 11.244 15.3812 10.4997 13.9987 10.4997C12.4832 10.4997 11.6654 11.1017 11.6654 11.6663C11.6654 12.1027 11.6654 12.833 13.9987 12.833C18.0587 12.833 18.6654 15.0263 18.6654 16.333C18.6654 17.8357 17.4649 19.3477 15.1654 19.7338Z"
    fill="currentColor"
  />
</svg>
